module.exports = __webpack_public_path__ + "static/media/arrow-left.a2d889d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/iconic/arrow-left.svg
// module id = 780
// module chunks = 0